import { Feiertagsausgleich } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/feiertagsausgleichRegelung';
import { Mitarbeiter_Feiertagsausgleich } from '@/gql/graphql';

export function mapFeiertagsausgleich(
  feiertagsausgleich: Feiertagsausgleich,
): Mitarbeiter_Feiertagsausgleich {
  switch (feiertagsausgleich) {
    case 'KEINER':
      return Mitarbeiter_Feiertagsausgleich.Keiner;
    case 'STUNDENGUTSCHRIFT':
      return Mitarbeiter_Feiertagsausgleich.Stundengutschrift;
    case 'ZUSCHLAEGE':
      return Mitarbeiter_Feiertagsausgleich.Zuschlaege;

    default:
      feiertagsausgleich satisfies never;
      throw new Error(
        `Unexpected feiertagsausgleich: ${String(feiertagsausgleich)}`,
      );
  }
}
